export interface CallsNavigationState {
  returnTo?: string;
}

export function buildCallsListReturnTo(pathname: string, search: string): string {
  return `${pathname}${search}`;
}

export function readCallsReturnTo(state: unknown): string | undefined {
  if (!state || typeof state !== "object" || !("returnTo" in state)) {
    return undefined;
  }
  const value = (state as CallsNavigationState).returnTo;
  return typeof value === "string" && value.startsWith("/calls") ? value : undefined;
}

export function withCallsReturnTo<T extends Record<string, unknown>>(
  state: T | null | undefined,
  returnTo: string | undefined
): T & CallsNavigationState {
  if (!returnTo) {
    return (state || {}) as T & CallsNavigationState;
  }
  return { ...(state || {}), returnTo } as T & CallsNavigationState;
}